import styled from 'styled-components';
import { TypeStyle } from '../TypeStyle';
export const Button = styled.button `
  display: inline-flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  align-items: center;
  border: 1px solid ${o => o.theme.color.deprecated.obsidianLighter};
  border-radius: 5px;
  cursor: pointer;
  margin: 2px;
  padding: 5px 10px;
  min-height: 35px;
  white-space: nowrap;
  &:hover {
    background-color: ${o => o.theme.color.deprecated.stoneLight};
  }
`;
export const Adornment = styled.div ``;
export const Label = styled(TypeStyle.HeadlineMicro).attrs({ asTag: 'span' }) `
  /* Avoid superfluous line-height from causing misalignment */
  line-height: 0;
`;
//# sourceMappingURL=styles.js.map